module.exports = __webpack_public_path__ + "static/media/foodmaps_unselected.46ab702f.svg";